//@ts-nocheck
import React, { Fragment, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getLayoutServiceData,
  UpdateConditionalFieldValue,
  updateHideButton,
} from '../../../ReduxImpl/actions/index';
import { IReduxState } from '../../../ReduxImpl/reducers/index';
import {
  Label,
  ListFieldProps,
  FieldChangeCallback,
} from '@sitecore-jss/sitecore-jss-react-forms';
import { ValueFormField } from '@sitecore-jss/sitecore-jss-forms';
import { useTranslation } from 'react-i18next';

const RadioButtonListField: React.FunctionComponent<ListFieldProps> = (
  props
) => {
  const {
    field,
    field: {
      model: { items },
    },
    value,
    onChange,
    tracker,
    errors,
  } = props;

  const FieldValidationErrors = props.fieldValidationErrorsComponent;
  const dispatch = useDispatch();
  const fieldValues = useSelector((state: IReduxState) => state.fieldValues);
  const hideButton = useSelector((state: IReduxState) => state.hideButton);

  return (
    <Fragment>
      <Label {...props} />
      <div className="sitecore-jss-form--radiobuttonAlign">
        {items.map((item, index) => (
          <div className="sitecore-jss-form--radiobutton">
            <label key={item.itemId}>
              <input
                type="radio"
                className={field.model.cssClass}
                id={field.valueField.id + index}
                name={field.valueField.name}
                value={item.value}
                checked={value.some((v) => v === item.value)}
                onChange={(e) =>
                  handleOnChange(
                    field,
                    e.target.value,
                    onChange,
                    fieldValues,
                    hideButton,
                    dispatch
                  )
                }
                onFocus={() => tracker.onFocusField(field, value)}
                onBlur={() => tracker.onBlurField(field, value, errors)}
              />
              {/* {console.log("ITEMSS",field.model.cssClass)} */}
            </label>

            <label className="radiobuttonLabel">{item.text} </label>
          </div>
        ))}
      </div>

      <FieldValidationErrors {...props} />
    </Fragment>
  );
};

/**
 * @param {ValueFormField} field
 * @param {string} newValue
 * @param {FieldChangeCallback} callback
 */
function handleOnChange(
  field: ValueFormField,
  newValue: string,
  callback: FieldChangeCallback,
  fieldValues: any,
  hideButton: boolean,
  dispatch: any
) {
  const { t } = useTranslation();

  let valid = true;
  const errorMessages = [];

  fieldValues[field.model['conditionSettings'].fieldKey] = newValue;
  //console.log("NEW VALUES", newValue)
  dispatch(UpdateConditionalFieldValue(fieldValues));

  // custom client validation logic here
  if (field.model.required && !newValue) {
    valid = false;
    errorMessages.push(`${field.model.title} ${t('IsRequired')}`);
  }
  if (newValue === 'Non accetto') {
    dispatch(updateHideButton(hideButton));
    //console.log("SHOWWW", hideButton)
  }
  if (newValue === 'Accetto') {
    dispatch(updateHideButton(hideButton));
    //console.log("AfterSHOWWW", hideButton)
  }

  callback(field.valueField.name, [newValue], valid, errorMessages);
}

export default RadioButtonListField;
